import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { closeModalAction, openTextModalAction } from '../../actions/modal';
import { getTicketStatsByCustomerId } from '../../actions/tickets';
import Card from '../../common/Card';
import InLineLabelValue from '../../common/InLineLabelValue';
import LabelValueWithRadialProgressBar from '../../common/LabelValueWithRadialProgressBar';
import { SkeltonCardTwo } from '../../common/SkeltonCardTwo';
import { isUserChangesAllowed } from '../../utils/access';
import { getWalletDetailsById } from '../../actions/wallet';
import LabelValueWithIcon from '../../common/LabelValueWithIcon';
import { GET_WALLET_DETAILS_BY_ID_SUCCESS } from '../../types/wallet';
import { GetQueryParam } from '../../utils/common';
import { getOrgDetails } from '../../actions/org';
import Loader from '../../common/Loader';
import { convertIntoRupee } from '../../utils/utils';

const CustomerDetailsSkeletonLoader = () => {
    return (
        <div className='flex gap-4 h-full w-full' style={{ height: 'inherit' }}>
            <div className='w-1/3'>
                <SkeltonCardTwo className={'px-4'} arr={[1]} height={120} padding={2} />
            </div>
            <div className='w-2/3'>
                <SkeltonCardTwo className={'px-4'} arr={[1, 2, 3, 4, 5]} height={20} padding={2} />
            </div>
        </div>
    );
};

export const payment_terms_options = [
    { key: 1, value: 1, label: '0 Day' },
    { key: 2, value: 2, label: '15 Days' },
    { key: 3, value: 3, label: '30 Days' },
    { key: 4, value: 4, label: '60 Days' },
    { key: 5, value: 5, label: '45 Days' },
];

const CustomerInfo = () => {
    const dispatch = useDispatch();
    const orgDetail = useSelector((state) => state.org.orgDetail);
    const userWalletById = useSelector((state) => state.wallet.userWalletById);
    const isOrgDetailLoading = useSelector((state) => state.loading.isOrgDetailLoading);
    const isUserWalletByIdLoading = useSelector((state) => state.loading.isUserWalletByIdLoading);
    const selectedOrg = GetQueryParam('select_org');

    useEffect(() => {
        if (selectedOrg) {
            dispatch(getOrgDetails({ orgId: selectedOrg, callWalletDetails: true }));
        }
    }, [selectedOrg, dispatch]);

    const currentOrgDetail = useMemo(() => {
        if (orgDetail && orgDetail[selectedOrg]) {
            return orgDetail[selectedOrg];
        }
        return {};
    }, [orgDetail, selectedOrg]);

    const memeoizedWalletDetails = useMemo(() => {
        let w = {};
        if (userWalletById && currentOrgDetail?.user?.id && userWalletById[currentOrgDetail.user.id]) {
            w = userWalletById[currentOrgDetail?.user?.id];
        }
        return w;
    }, [userWalletById, currentOrgDetail?.user?.id]);

    if (isOrgDetailLoading) return (
        <div className='h-full flex items-center justify-center'>
            <Loader />
        </div>
    );

    if (currentOrgDetail) {
        return (
            <div className='h-full'>
                <div className='h-6/12'>
                    <Card title='Customer Details' icon={'person'} isLoading={false} loaderComponent={<CustomerDetailsSkeletonLoader />}>
                        <div className='grid grid-cols-4  gap-x-3 h-full auto-rows-fr px-10 py-4'>
                            <div className='row-span-4 flex items-center justify-center'>
                                <img
                                    src={
                                        currentOrgDetail.logo ? currentOrgDetail.logo : process.env.PUBLIC_URL + '/img/default_customer_logo.png'
                                    }
                                    alt=''
                                    className='w-96'
                                    style={{ maxHeight: '10rem' }}
                                />
                            </div>
                            <InLineLabelValue label={'Company Name'} value={currentOrgDetail.name} />
                            <InLineLabelValue label={'Owner Name'} value={currentOrgDetail?.user?.full_name} />
                            <InLineLabelValue label={'Owner Email'} value={currentOrgDetail?.user?.email} />
                            <InLineLabelValue label={'Owner Mobile'} value={currentOrgDetail?.user?.mobile} />
                            {/* <InLineLabelValue label={'PAN Number'} value={currentOrgDetail.name} /> */}
                            {currentOrgDetail.gst && <InLineLabelValue label={'GST Number'} value={currentOrgDetail.gst} />}
                            {/* <InLineLabelValue label={'GST State'} value={transformedCustomerDetails?.gst_state} /> */}
                            {/* <InLineLabelValue label={'Payment Terms'} value={transformedCustomerDetails?.payment_terms} /> */}
                            <InLineLabelValue label={'Domain'} value={currentOrgDetail?.domain?.[0] || '-'} />
                            <InLineLabelValue parentClass={'col-span-3'} label={'Address'} value={currentOrgDetail?.address?.user_input} />
                        </div>
                    </Card>
                </div>
                <div className='h-6/12 w-full flex gap-4'>
                    <div className='h-full w-1/2 pt-6'>
                        {Object.keys(memeoizedWalletDetails).length > 0 ? <Card title='Wallet Details' icon={'wallet'} isLoading={isUserWalletByIdLoading} >
                            {memeoizedWalletDetails && <div className='grid grid-cols-2 items-center justify-center h-full px-4'>
                                <LabelValueWithIcon value={convertIntoRupee(memeoizedWalletDetails.balance)} label={'Current Balance'} icon={'currency_rupee'} />
                                <LabelValueWithIcon value={convertIntoRupee(memeoizedWalletDetails.locked)} label={'Reserved Amount'} icon={'lock'} />
                                <LabelValueWithIcon value={convertIntoRupee(memeoizedWalletDetails.total_wallet_transfer)} label={'Amount Paid'} icon={'wallet'} />
                            </div>}
                        </Card> : null}
                    </div>
                    <div className='h-full w-1/2 pt-6'>
                        {/* {ticketStats && <Card title='Ticket Statistics' icon={'timeline'} isLoading={isTicketStatsLoading}>
                            <div className='grid grid-cols-2 items-center justify-items-stretch gap-x-12 h-full px-14'>
                                <LabelValueWithRadialProgressBar label='Open Tickets' total={ticketStats?.totalTicket} value={ticketStats?.openTicket} color={'#F48A21'} />
                                <LabelValueWithRadialProgressBar label='Closed Tickets' total={ticketStats?.totalTicket} value={ticketStats?.closedTicket} color={'#12355F'} />
                            </div>
                        </Card>} */}
                    </div>
                </div>
            </div>
        );
    }
    return <div>No Customer Found</div>
};

export default CustomerInfo;
